import * as React from 'react'
import * as R from 'ramda'
import {ChooseManufacturerState} from './ChooseManufacturerState'
import {ChooseManufacturerAction} from './ChooseManufacturerActions'
import {PublicPage} from '../../View/PublicPage'
import Select from 'material-ui-next/Select'
import {FormControl, FormHelperText} from 'material-ui-next/Form'
import Input, {InputLabel} from 'material-ui-next/Input'
import RaisedButton from 'material-ui/RaisedButton'
import MenuItem from 'material-ui/MenuItem'
import {IntermediateSession} from '../../Data/IntermediateSession'
import {errorMessage} from '../../Data/FormValidation'
import injectSheet from 'react-jss'
import {WithClasses} from '../../View/Helper'

const styles = {
    loginForm: {
        textAlign: 'center',
        padding: '16px'
    },
}

interface Properties {
    intermediateSession: IntermediateSession,
    state: ChooseManufacturerState,
    dispatch: (action: ChooseManufacturerAction) => void,
}

export const ChooseManufacturer =
    injectSheet<Properties>(styles)(
        ({classes, intermediateSession, state, dispatch}: WithClasses<Properties>) => (
            <PublicPage>
                <form
                    className={classes.loginForm}
                    onSubmit={(event) => {
                        event.preventDefault()
                        dispatch({
                            type: 'Submit',
                        })
                    }}
                >
                    <FormControl fullWidth={true}>
                        <InputLabel htmlFor="manufacturer-input-id">
                            Produzent
                        </InputLabel>
                        <Select
                            style={{textAlign: 'left'}}
                            fullWidth={true}
                            value={state.input.manufacturerId}
                            onChange={
                                event => dispatch({
                                    type: 'ManufacturerChanged',
                                    value: event.target.value,
                                })
                            }
                            input={
                                <Input
                                    name="manufacturerId"
                                    id="manufacturer-id-input"
                                />
                            }
                        >
                            {R.map(
                                manufacturer =>
                                    <MenuItem
                                        value={manufacturer.id.toString()}
                                        key={manufacturer.id}
                                    >
                                        {manufacturer.name}
                                    </MenuItem>,
                                intermediateSession.manufacturers,
                            )}
                        </Select>
                        <FormHelperText error={true}>
                            {errorMessage(state.validation.manufacturerId)}
                        </FormHelperText>
                    </FormControl>
                    <RaisedButton
                        label="Auswählen"
                        type="submit"
                        primary={true}
                        className="login__btn"
                    />
                </form>
            </PublicPage>
        )
    )



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/ChooseManufacturer/ChooseManufacturerView.tsx